import { Helmet } from "react-helmet";
import { CheckoutComponentChatAttibutesType } from "../../types/builder";

const FreshChat: React.FC<
  Pick<CheckoutComponentChatAttibutesType, "accountId">
> = ({ accountId }) => {
  return (
    <Helmet>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <script src={`//fw-cdn.com/${accountId}.js`} async chat="true"></script>
    </Helmet>
  );
};

export default FreshChat;
